"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestSettingTable = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../../../Colors");
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const server_1 = require("../../../../../server");
const popup_1 = require("../../../../base/popup");
const DSTL001_1 = require("../../../DSTL001");
const DSTL001_List_Child_1 = require("../../../DSTL001/component/DSTL001_List_Child");
const TestSetting_1 = require("./TestSetting");
const TestSettingStyled = styled_components_1.default.div `
	width: 100%;
	${props => props.$isMobile &&
    props.$isTablet &&
    (0, styled_components_1.css) `
			flex: 1;
			height: 100%;
		`}

	display: flex;
	flex-direction: column;

	.live-list-002 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		height: 516px;
		position: relative;
		overflow: hidden;
		flex: 1;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			align-self: stretch;

			color: var(--color-grey, #666666);
			text-align: left;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			font-weight: var(--b3-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
	}

	.underbar_line {
		cursor: pointer;
		color: var(--color-accent, #e7424c);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 28px;
		font-weight: 400;
		text-decoration: underline;
		position: relative;
		width: 38px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	${props => (props.$isMobile ? mobileSytles : props.$isTablet ? tabletStyles : desktopStyles)}
`;
const mobileSytles = (0, styled_components_1.css) `
	gap: 6px;
	.live-list-002 {
		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 1px 0px 0px 0px;
			padding: 12px;
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: center;
			justify-content: space-between;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			flex: 1;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;

			&:nth-child(1) {
				border-width: 0px;
			}
			&:nth-last-child(1) {
				border-width: 0px;
			}
		}
	}

	.bold {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 700;
		position: relative;
		align-self: stretch;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}

	.underbar_line {
		text-align: end;
		width: 100%;
	}

	.btn-container {
		width: 100%;
		padding-bottom: 4px;
		.sm {
			flex: 1;
		}
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	gap: 13px;
	.live-list-002 {
		.item {
			padding: 8px 16px 8px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
			position: relative;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	gap: 13px;
	.test-setting-list {
		min-height: 180px;
	}

	.live-list-002 {
		.item {
			padding: 8px 16px 8px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			color: var(--color-black, #101010);
			text-align: left;
			font-family: var(--b4-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b4-font-size, 14px);
			line-height: var(--b4-line-height, 28px);
			font-weight: var(--b4-font-weight, 400);
			position: relative;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}
`;
const COUNT = 10;
exports.TestSettingTable = react_1.default.memo(({ isDetail = false, isModify = false, conference_id, conferenceStart, conferenceEnd, item, choice, setItem, setChoice, deferred = false, pendingTests = [], setPendingTests, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet, classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    const [load, setLoad] = (0, react_1.useState)(false);
    const [testData, setTestData] = (0, react_1.useState)([]);
    const [totalCount, setTotalCount] = (0, react_1.useState)(0);
    // 삭제 API 중복 호출 방지 가드
    const [deleting, setDeleting] = (0, react_1.useState)(false);
    // 테스트 삭제 뮤테이션 (테스트 목록 삭제와 동일하게 실제 삭제 API 호출)
    const deleteMutation = (0, react_query_1.useMutation)(server_1.deleteAssignmentList);
    // 강의에 연결된 테스트(id: choice)를 id 로 특정 조회하므로 assignment/survey 필터를 걸지 않는다.
    // (설계안 갖고오기로 선택한 항목이 assignment/survey 값과 무관하게 '테스트 설정' 목록에 노출되도록 함)
    const { data, refetch } = (0, server_1.useAssignmentList)({
        id: choice,
        class_id: classesId,
    });
    (0, react_1.useEffect)(() => {
        if (choice.length > 0) {
            refetch();
        }
    }, [choice]);
    // 지연 생성 모드에서 아직 생성되지 않은 pending payload 를 목록에 임시 항목으로 표시하기 위한 매핑.
    // 임시 id(tempId)는 서버에 존재하지 않으므로 choice/useAssignmentList 조회에는 절대 넣지 않는다.
    const pendingRows = (0, react_1.useMemo)(() => pendingTests.map(p => ({
        id: p.tempId,
        title: p.title,
    })), [pendingTests]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { total_count, items } = data;
            if (total_count > 0) {
                setItem(items.map(i => i.id));
                setTestData([...items, ...pendingRows]);
                setTotalCount(total_count + pendingRows.length);
                return;
            }
        }
        if (item.length === 0) {
            setTestData([...pendingRows]);
            setTotalCount(pendingRows.length);
        }
    }, [data, pendingRows]);
    const { headTitleList, tableReadDataKeys } = (0, react_1.useMemo)(() => ({
        headTitleList: [
            { title: 'testName', space: 3, sort: false, maxWidth: 250 },
            ...(isDetail ? [] : [{ title: 'etc', space: 1, sort: false }]),
        ],
        tableReadDataKeys: [
            { title: 'title', space: 3, sort: false, maxWidth: 250 },
            ...(isDetail ? [] : [{ title: 'etc', space: 1, sort: false }]),
        ],
    }), [isDetail]);
    const openAddSetting = () => {
        // 테스트 등록은 하나만 — 이미 저장된(item) + 지연 생성 대기(pending) 합산으로 판단
        if (item.length + pendingTests.length >= 1) {
            alert('테스트 등록은 하나만 가능합니다.');
            return;
        }
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DSTL001_1.DSTP001_Regist,
            componentProps: {
                isTeacher: true,
                isTest: true,
                isReserve: true,
                // 지연 생성 모드: 즉시 생성 대신 payload 를 부모(DSTT001) pending 목록에 보관.
                // 그 외(수정 모드 등)는 기존처럼 setChoice 로 즉시 생성된 테스트 id 를 반영.
                ...(deferred && setPendingTests
                    ? {
                        onDeferredTest: (payload) => setPendingTests(prev => [...prev, payload]),
                    }
                    : { setUpdateCheckList: setChoice }),
                isLive: true,
                isPopup: true,
                // 강의(수업) 시작/종료일시 전달 — 테스트 시작/종료·풀이시간 범위 검증에 사용
                conferenceStart,
                conferenceEnd,
            },
            noPadding: true,
            width: 757,
            title: '테스트 등록',
        });
    };
    const openAssignment = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DSTL001_List_Child_1.AssignmentTable,
            componentProps: {
                isTest: true,
                isReserve: true,
                isTeacher: true,
                defaultCheckList: testData.map(i => i.id),
                setUpdateCheckList: setChoice,
                conference_id,
                isReserveRegist: !isModify,
            },
            width: 757,
            title: t('conference.testDownload'),
        });
    };
    const deleteCheckList = async (id) => {
        // 지연 생성 임시 항목(pending)은 서버에 없으므로 API 없이 pending 목록에서만 제거.
        if (id.startsWith('pending_')) {
            setPendingTests && setPendingTests(prev => prev.filter(p => p.tempId !== id));
            setTestData(prev => prev.filter(i => i.id !== id));
            return;
        }
        // 중복 클릭 방지
        if (deleting)
            return;
        setDeleting(true);
        try {
            // 서버에서 테스트를 실제 삭제 (예약 저장 전 취소가 아니라 즉시 삭제)
            await deleteMutation.mutateAsync(id);
            // 삭제 성공 시에만 로컬 목록 3개에서 제거
            setChoice(choice.filter(itemId => itemId !== id));
            setItem(item.filter(itemId => itemId !== id));
            setTestData(prev => prev.filter(i => i.id !== id));
        }
        catch (error) {
            console.error('Failed to delete test:', error);
            // 실패 시 목록 유지 후 사용자 알림
            alert('테스트 삭제에 실패했습니다. 다시 시도해주세요.');
        }
        finally {
            setDeleting(false);
        }
    };
    const renderTitle = (0, react_1.useMemo)(() => (react_1.default.createElement(TestSetting_1.TestSetting, { tableName: t('conference.testSetting') }, !isDetail && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.Button, { className: "btn_default sm", text: t('conference.enroll'), onClick: openAddSetting }),
        react_1.default.createElement(common_1.Button, { className: "btn_default sm", text: isMobile
                ? t('conference.testAdd')
                : t('conference.testDownload'), onClick: openAssignment }))))), [testData, isDetail, isModify, item, isMobile, conferenceStart, conferenceEnd, pendingTests, deferred]);
    const renderItem = (item, styles) => tableReadDataKeys.map(headItem => (react_1.default.createElement("div", { key: headItem.title, style: {
            flex: headItem.space,
            maxWidth: headItem?.maxWidth,
            ...styles?.bodyItem,
            overflow: 'hidden',
        } }, headItem.title === 'etc' ? (react_1.default.createElement("p", { className: "underbar_line", onClick: () => deleteCheckList(item.id) }, t('common.delete'))) : (react_1.default.createElement("p", { className: "overText" }, item[headItem.title])))));
    const renderEmpty = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: "empty_data", style: { color: Colors_1.Colors.light_grey } },
        react_1.default.createElement(common_1.Icon, { icon: "detail-delete", size: 36, fill: Colors_1.Colors.w_grey }),
        react_1.default.createElement("p", null, "\uB4F1\uB85D\uB41C \uD14C\uC2A4\uD2B8\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."))), []);
    return (react_1.default.createElement(TestSettingStyled, { "$isTablet": isTablet, "$isMobile": isMobile, className: "user-list test-setting-list" },
        react_1.default.createElement(common_1.Table, { className: "live-list-002", forceShowheader: !isMobile, showCheckBox: false, showIndex: !isMobile, indexOrder: "desc", isInfinite: true, data: testData, totalCount: totalCount, page: 0, showCount: COUNT, sortDefault: "id", headTitleList: headTitleList, renderTitle: renderTitle, renderItem: renderItem, renderEmpty: isDetail && totalCount <= 0 && renderEmpty, padding: false })));
});
